import { MenuTypes } from '@/models/Menu/Constants';
export var factoryMenuSetting = function (menuType, menuSetting) {
    switch (menuType) {
        case MenuTypes.Geo:
            return menuSetting;
        case MenuTypes.Automobile:
            return menuSetting;
        case MenuTypes.Newspaper:
            return menuSetting;
        case MenuTypes.Retargeting:
            return menuSetting;
        case MenuTypes.Pta:
            return menuSetting;
        case MenuTypes.GeoGenome:
            return menuSetting;
        case MenuTypes.CustomGeo:
            return menuSetting;
        case MenuTypes.Railway:
            return menuSetting;
        default:
            return menuSetting;
    }
};
export default factoryMenuSetting;
